import { FC, SVGProps } from 'react';

export const TicketLocationIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
		<path
			d="M12.8227 11.6914C15.3674 12.1448 17.1658 13.2219 17.1658 14.4702C17.1658 16.1462 13.9784 17.4979 10.0448 17.4979C6.11206 17.4979 2.91638 16.1462 2.91638 14.4702C2.91638 13.2219 4.70656 12.1531 7.25946 11.6914"
			stroke="currentColor"
			strokeWidth="1.09821"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M12.9625 5.42006C12.9625 7.0332 11.6546 8.34111 10.0415 8.34111C8.42751 8.34111 7.11963 7.0332 7.11963 5.42006C7.11963 3.80692 8.42751 2.49902 10.0415 2.49902C11.6546 2.49902 12.9625 3.80692 12.9625 5.42006Z"
			stroke="currentColor"
			strokeWidth="1.09821"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M10.0402 8.34131L10.0396 14.0515"
			stroke="currentColor"
			strokeWidth="1.09821"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
